import { useEffect, useState } from "react";
import { IFormBuilderProps } from "./interface";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faInfoCircle, faPlus, faTimes, faTrash } from "@fortawesome/free-solid-svg-icons";
import "./FormBuilder.scss";
import classNames from "classnames";

// Form supports fields of type
// 1. Number
// 2. Password
// 3. Single Select
// 4. Checkbox
// 5. Text
// 6. AddDynamicFields ( Custom)


export default function FormBuilder({ config, setInputFormData, setRowsAPI, rowsAPI, finalSubmit, setRequiredFieldData, requiredFieldData, requestedPage, defaultValuesFromGet, singleDependency }: IFormBuilderProps) {
    const [searchValue, setSearchValue] = useState<any>({});
    const [inputs, setInputs] = useState<any>({});
    const [requiredFields, setRequiredFields] = useState<any>(config);
    const [rowsData, setRowsData] = useState<any>([]);
    const [icon, setIcon] = useState<any>("faEyeSlash");
    const [dependantDisableKeys, setDependantDisableKeys] = useState<any>({});
    const [hideShowPassword, setHideShowPasword] = useState<any>({});

    useEffect(() => {
        const temp = [...rowsData]
        setRowsAPI && setRowsAPI(temp)
    }, [rowsData])


    useEffect(() => {
        setInputFormData && setInputFormData(inputs);
    }, [inputs, Object.keys(inputs).length])

    useEffect(() => {
        removeInputs();
        setRequiredFieldData && setRequiredFieldData(requiredFields)
        setInputFormData && setInputFormData(inputs);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requiredFields, requiredFields?.length]);

    useEffect(() => {
        if (defaultValuesFromGet) {
            // insertDefaultValues(requiredFields, defaultValuesFromGet)
        }
    }, [defaultValuesFromGet, requiredFields, requiredFields?.length])
    useEffect(() => {
        requiredFields?.forEach((x: any, index: number) => {
            if (inputs[x?.key]) {
                setInputs((values: any) => ({ ...values, [x?.key]: x?.defaultValue }));
            }
            else if (x?.dynamicFields) {
                // addContainerTableRows(x?.dynamicFields)
            }
            else if (typeof (x?.defaultValue) === "boolean") {
                setInputs((values: any) => ({ ...values, [x?.key]: x?.defaultValue }));
                if (x?.dependencyList) {
                    addRemoveFields(x?.dependencyList, x?.defaultValue, x?.key)
                }
                else if (x?.dynamicFields) {
                    // console.log(x?.dynamicFields);
                }
            }
            else if (typeof (x?.defaultValue) !== "boolean") {
                setInputs((values: any) => ({ ...values, [x?.key]: x?.defaultValue }));
                if (x?.dependencyList) {
                    addRemoveFields(x?.dependencyList, x?.defaultValue, x?.key)
                }
                else if (x?.dynamicFields) {
                    // console.log(x?.dynamicFields);
                }
            }
            else if (checkDefaultSelect(x?.options)) {
                setInputs((values: any) => ({ ...values, [x?.key]: checkDefaultSelectValue(x?.options) }));
                if (x?.dependencyList) {
                    addRemoveFields(x?.dependencyList, x?.defaultValue, x?.key)
                }
            }
        })
    }, []);

    const show = (iconName: any, key: any) => {
        if (hideShowPassword?.[key]) {
            setIcon("faEye")
            hideShowPassword[key] = false;
        }
        else {
            setIcon("faEyeSlash")
            hideShowPassword[key] = true;
        }
        setHideShowPasword(hideShowPassword);
    };

    const insertDefaultValues = (requiredFieldDataa: any, defaultData: any) => {
        let reqFieldsTemp: any = requiredFieldDataa;
        for (var propt in defaultData) {
            const ind: any = reqFieldsTemp?.findIndex((dataEle: any) => dataEle?.key === propt)
            if (ind > -1) {
                if (reqFieldsTemp[ind]["defaultValue"]) {
                    // requiredFieldDataa[ind]["defaultValue"] = defaultData[propt];
                    // requiredFieldData[ind]?.["defaultValue"] = defaultData[propt];
                }
                else {
                    reqFieldsTemp[ind]["defaultValue"] = defaultData[propt];
                }
            }
            else {
                // console.log(ind)
            }
        }
        setRequiredFields(reqFieldsTemp);
    }

    const addContainerTableRows = (key?: any, defaultAddOptions?: any) => {
        if (defaultAddOptions?.length > 0) {
            let reqRowData: any = rowsData;
            let reqInputData: any = inputs;
            defaultAddOptions.map((element: any) => {
                const rowsInput: any = element;
                reqRowData = [...reqRowData, rowsInput];
                reqInputData = [...reqRowData, rowsInput]
            });
            setRowsData(reqRowData);
            setInputs((values: any) => ({ ...values, [key]: reqRowData }));
        }
        else {
            const rowsInput: any =
            {
                label: "",
                value: ""
            }
            setRowsData([...rowsData, rowsInput])
            setInputs((values: any) => ({ ...values, [key]: [...rowsData, rowsInput] }));
        }
    }

    const deleteTableRows = (index: number, key?: any) => {
        const rows = [...rowsData];
        rows.splice(index, 1);
        const temp = JSON.parse(JSON.stringify(rows));
        setInputs((values: any) => ({ ...values, [key]: temp }));
        setRowsData(temp);
    }

    const handleChangeAddAPI = (index: number, evnt: any) => {
        const nam = evnt.target.name;
        const value = evnt.target.value;
        const rowsInput = rowsData;
        rowsInput[index][nam] = value ? value : "";
        setRowsData(rowsInput);
        setInputs((values: any) => ({ ...values, "dynamicAddAPIs": rowsInput }));
    }

    const checkDefaultSelect = (optionData: any) => {
        let flag: boolean = false;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        let reqValue: any;
        optionData?.forEach((item: any, index: number) => {
            if (item?.selected) {
                flag = true;
                reqValue = item?.value;
            }
        })
        return flag;
    }

    const checkDefaultSelectValue = (optionData: any) => {
        let reqValue: any;
        optionData?.forEach((item: any, index: number) => {
            if (item?.selected) {
                reqValue = item?.value;
            }
        })
        return reqValue;
    }

    const removeInputs = () => {
        let updatedInputs: any = {}
        requiredFields && requiredFields?.forEach((item: any, index: number) => {
            if (item?.key && (item?.key in inputs)) {
                if (item?.key === "dynamicAddAPIs") {
                    setRowsData(inputs[item?.key])
                }
                else {
                    setRowsData([]);
                }
                updatedInputs[item?.key] = inputs[item?.key];
            }
        })
        setInputs(updatedInputs);
    }

    const dataCheck = (requiredUpdatedFields?: any, key?: any) => {
        requiredUpdatedFields?.forEach((x: any, index: number) => {
            if (key === x?.key) {
                if (x?.defaultValue || x?.defaultValue === 0) {
                    if (x.key in inputs) {
                        setInputs((values: any) => ({ ...values, [x?.key]: x?.defaultValue }));
                        if (x?.dependencyList) {
                            addRemoveFields(x?.dependencyList, x?.defaultValue, x?.key)
                        }
                    }
                    else {
                        setInputs((values: any) => ({ ...values, [x?.key]: x?.defaultValue }));
                        if (x?.dependencyList) {
                            addRemoveFields(x?.dependencyList, x?.defaultValue, x?.key)
                        }
                    }
                }
                else {
                    if (x.key in inputs) {
                        setInputs((values: any) => ({ ...values, [x?.key]: "" }));
                        if (x?.dependencyList) {
                            addRemoveFields(x?.dependencyList, x?.defaultValue, x?.key)
                        }
                    }
                }
                if (x?.options) {
                    if (checkDefaultSelect(x?.options)) {
                        // setInputs((values: any) => ({ ...values, [x?.key]: checkDefaultSelectValue(x?.options) }));
                        if (x?.dependencyList) {
                            addRemoveFields(x?.dependencyList, x?.defaultValue, x?.key)
                        }
                    }
                }
            }
        })
    }

    const setSearchValues = (value: any, field: any) => {
        try {
            let tempSearch = JSON.parse(JSON.stringify(searchValue));
            tempSearch[field?.key] = value;
            setSearchValue(tempSearch);
        } catch (error) {
            console.log("error", error);
        }
    }

    const removeAdditionalFields = (tempRequiredFields: any, dependencyChildList: any, parentKeyName: any) => {
        let temp: any = JSON.parse(JSON.stringify(tempRequiredFields));
        temp?.forEach((item: any, index: number) => {
            if (item?.key !== parentKeyName) {
                const ind: any = dependencyChildList.findIndex((dataEle: any) => dataEle?.key === item?.key)
                if (ind === -1) {
                    const index: any = tempRequiredFields.findIndex((dataEle: any) => dataEle?.key === item?.key)
                    if (index > -1) {
                        tempRequiredFields.splice(index, 1);

                    }
                }
                else {
                    // console.log(dependencyChildList[ind]);
                }
            }
        })
        return tempRequiredFields;
    }

    const addRemoveFields = (dependencyList: any, value: any, parentKeyName?: any) => {
        if (singleDependency) {
            let tempRequiredFields: any = JSON.parse(JSON.stringify(requiredFields));
            let reqValue = String(value);
            for (let key in dependencyList) {
                if (key === reqValue) {
                    dependencyList[key]?.forEach((item: any, index: number) => {
                        const ind: any = tempRequiredFields.findIndex((dataEle: any) => dataEle?.key === item?.key)
                        if (ind === -1) {
                            tempRequiredFields.push(item);
                            if (item?.dynamicFields && item?.dynamicFieldValue) {
                                addContainerTableRows("dynamicAddAPIs", item?.["dynamicFieldValue"])
                            }
                            if (item?.defaultValue || item?.defaultValue === 0) {
                                dataCheck(tempRequiredFields, item?.key);
                            }
                            if (item?.dependencyList) {
                                // console.log(dependencyList);
                            }
                            if (item?.hide) {
                                // console.log(item.key)
                            }
                        }
                        else {
                            const innerInd: any = dependencyList[key].findIndex((dataEle: any) => dataEle?.key === tempRequiredFields[ind]?.key)
                            if (innerInd > -1) {
                                tempRequiredFields.splice(ind, 1, dependencyList[key][innerInd]);
                                if (dependencyList[key][innerInd]?.defaultValue) {
                                    dataCheck(tempRequiredFields, dependencyList[key][innerInd]?.key);
                                }
                                else {
                                    dataCheck(tempRequiredFields, dependencyList[key][innerInd]?.key);
                                }
                            }
                            else {
                                tempRequiredFields.splice(ind, 1);
                            }
                        }
                    })
                    removeAdditionalFields(tempRequiredFields, dependencyList[key], parentKeyName);
                    setRequiredFields(tempRequiredFields)
                }
                else if (reqValue.length === 0) {
                    dependencyList[key]?.forEach((item: any) => {
                        const ind: any = requiredFields.findIndex((dataEle: any) => dataEle?.key === item?.key)
                        if (ind > -1) {
                            requiredFields.splice(ind, 1);
                        }
                        else {
                            // console.log("test");
                        }
                    })
                }
            }
        }
        else {
            let reqValue = String(value);
            for (let key in dependencyList) {
                if (key === reqValue) {
                    dependencyList[key]?.forEach((item: any, index: number) => {
                        const ind: any = requiredFields.findIndex((dataEle: any) => dataEle?.key === item?.key)
                        if (ind === -1) {
                            requiredFields.push(item);
                            if (item?.dynamicFields && item?.dynamicFieldValue) {
                                addContainerTableRows("dynamicAddAPIs", item?.["dynamicFieldValue"])
                            }
                            if (item?.defaultValue || item?.defaultValue === 0) {
                                dataCheck(requiredFields, item?.key);
                            }
                            if (item?.dependencyList) {
                                // addRemoveFields(item?.dependencyList, value, item?.key)
                            }
                            if (item?.hide) {
                                hideShowPassword[item.key] = item.hide;
                            }
                        }
                        else {
                            requiredFields.splice(ind, 1);
                        }
                    })
                    setHideShowPasword(hideShowPassword);
                    setRequiredFields(requiredFields)
                }
                else {
                    dependencyList[key]?.forEach((item: any) => {
                        if (item?.dependencyList) {
                            const ind: any = requiredFields.findIndex((dataEle: any) => dataEle?.key === item?.key)
                            if (ind > -1) {
                                requiredFields.splice(ind, 1);
                            }
                            addRemoveFields(item?.dependencyList, value, item?.key)
                        }
                        else if (item?.dynamicFields) {
                            if (item?.dynamicFieldValue) {
                            }
                            const ind: any = requiredFields.findIndex((dataEle: any) => dataEle?.key === item?.key)
                            if (ind > -1) {
                                requiredFields.splice(ind, 1)
                            }
                        }
                        else {
                            const ind: any = requiredFields.findIndex((dataEle: any) => dataEle?.key === item?.key)
                            if (ind > -1) {
                                requiredFields.splice(ind, 1);
                            }
                        }
                        if (item?.hide) {
                            hideShowPassword[item.key] = item.hide;
                        }
                        setHideShowPasword(hideShowPassword);
                        setRequiredFields(requiredFields)
                    })
                }
            }
        }
    }

    // Handling OnChange of every Input
    const handleChange = (event: any, dependencyList?: any, restrictSpecialCharacters?: boolean, entireObject?: any) => {
        const name = event.target.name;
        const value = event.target.value;
        if (restrictSpecialCharacters) {
            if (value.match(/[^\w\.\-]/) === null) {
                setInputs((values: any) => ({ ...values, [name]: event.target.value }));
                if (Object.keys(dependencyList).length > 0) {
                    addRemoveFields(dependencyList, event.target.value, name)
                }
            }
            // else {
            //     console.log(value.match(/[^\w\.\-]/));
            // }
        }
        else {
            if (entireObject && entireObject?.dataType === "number") {
                if (event.target.value) {
                    setInputs((values: any) => ({ ...values, [name]: Number(event.target.value) }));
                    if (dependencyList && Object.keys(dependencyList)?.length > 0) {
                        addRemoveFields(dependencyList, Number(event.target.value), name)
                    }
                }
                else {
                    setInputs((values: any) => ({ ...values, [name]: Number(event.target.value) }));
                    if (dependencyList && Object.keys(dependencyList)?.length > 0) {
                        addRemoveFields(dependencyList, Number(event.target.value), name)
                    }
                }
            }
            else {
                setInputs((values: any) => ({ ...values, [name]: event.target.value }));
                if (dependencyList && Object.keys(dependencyList)?.length > 0) {
                    addRemoveFields(dependencyList, event.target.value, name)
                }
            }
        }
    }

    // useEffect(() => {
    //     console.log(dependantDisableKeys);
    // }, [dependantDisableKeys, Object.keys(dependantDisableKeys).length])

    const handleCheckBox = (event: any, dependencyList?: any, entireObject?: any) => {
        if (entireObject?.dependantDisableKeys) {
            setDependantDisableKeys((values: any) => ({ ...values, [event?.target?.name]: entireObject?.dependantDisableKeys }));
        }
        if (dependencyList) {
            addRemoveFields(dependencyList, !!event.target.checked, event?.target?.name)
        }
        const name = event.target.name;
        setInputs((values: any) => ({ ...values, [name]: !!event.target.checked }));
    }

    const onClearInput = (selectedKey: any, dependencyList?: any) => {
        if (dependencyList && Object.keys(dependencyList)?.length > 0) {
            setInputs((values: any) => ({ ...values, [selectedKey?.key]: "" }));
            addRemoveFields(dependencyList, "", selectedKey?.key)
        }
        else if (selectedKey.key) {
            let tempInput = JSON.parse(JSON.stringify(inputs))
            delete tempInput[selectedKey.key];
            setInputs(tempInput);
        }
        else {
            let tempInput = JSON.parse(JSON.stringify(inputs))
            delete tempInput[selectedKey];
            setInputs(tempInput);
        }
    }

    return (
        <div className="form-builder">
            <form className="form-builder">
                {requestedPage === "deviceSettings" ?
                    <div>
                        {requiredFields?.length ?
                            <>
                                {requiredFields?.length && requiredFields?.map((field: any) => {
                                    return (
                                        <div className="m-2 row">
                                            {field?.type &&
                                                <> {field?.type !== "checkBox" &&
                                                    <div className="d-flex col-md-12 col-sm-12">
                                                        <label className="field-label">
                                                            {field?.label}
                                                            {field.optional && (
                                                                <span className="optional">(optional)</span>
                                                            )}
                                                        </label>
                                                        {field.required &&
                                                            <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                                        }
                                                        {field?.tooltip && (
                                                            <div className="ml-2">
                                                                <div className="pointer" data-toggle="tooltip" data-placement="top" title={field?.tip}>
                                                                    <FontAwesomeIcon icon={faInfoCircle} className="m-0 ps-1 fontCircleInfo" />
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                }
                                                </>
                                            }
                                            {field?.type && field?.type === "input" && field?.dataType !== "number" && (
                                                <div className="col-md-6 col-sm-12">
                                                    <div className="d-flex">
                                                        <input
                                                            type={field?.dataType}
                                                            name={field?.key}
                                                            value={inputs[field?.key] ? (inputs[field?.key] === 0 ? 0 : inputs[field?.key]) : inputs[field?.key] === 0 ? 0 : ""}
                                                            id={field?.key}
                                                            className="form-control form-control-bordered"
                                                            placeholder={field?.placeholder}
                                                            required={field.required ? field.required : false}
                                                            disabled={field?.disableDependency ? (inputs?.[field?.disableDependency] === true ? false : true) : false}
                                                            // disabled={field?.disabled}
                                                            onChange={(e) => { field?.restrictSpecialCharacters ? handleChange(e, {}, field?.restrictSpecialCharacters, field) : handleChange(e, {}, false, field) }}
                                                        />
                                                        <span className="input-group-append">
                                                            <div className="input-group-text bg-transparent input-clear-pos pointer" onClick={() => { onClearInput(field?.key) }}>
                                                                <FontAwesomeIcon icon={faTimes} />
                                                            </div>
                                                        </span>
                                                    </div>
                                                    {finalSubmit && !inputs[field?.key] && field.required &&
                                                        <div className="error-text">
                                                            Please Enter {field?.label}
                                                        </div>
                                                    }
                                                </div>
                                            )}
                                            {field?.type && field?.type === "input" && field?.dataType === "number" && (
                                                <div className="col-md-6 col-sm-12">
                                                    <div className="d-flex">
                                                        <input
                                                            type="number"
                                                            name={field?.key}
                                                            value={typeof (inputs[field?.key]) === "number" ? inputs[field?.key] : ""}
                                                            defaultValue={inputs[field?.key]}
                                                            id={field?.key}
                                                            className="form-control form-control-bordered"
                                                            placeholder={field?.placeholder}
                                                            required={field.required ? field.required : false}
                                                            disabled={field?.disableDependency ? (inputs?.[field?.disableDependency] === true ? false : true) : false}
                                                            onChange={(e: any) => { field?.restrictSpecialCharacters ? handleChange(e, {}, field?.restrictSpecialCharacters, field) : handleChange(e, {}, false, field) }}
                                                        />
                                                        <span className="input-group-append">
                                                            <div className="input-group-text bg-transparent input-clear-pos pointer" onClick={() => { onClearInput(field?.key) }}>
                                                                <FontAwesomeIcon icon={faTimes} />
                                                            </div>
                                                        </span>
                                                    </div>
                                                    {finalSubmit && typeof (inputs[field?.key]) !== "number" &&
                                                        <>
                                                            {field?.disableDependency ?
                                                                <>
                                                                    {
                                                                        inputs?.[field?.disableDependency] === true ?
                                                                            <div className="error-text">
                                                                                Please Enter {field?.label}
                                                                            </div>
                                                                            :
                                                                            <></>
                                                                    }

                                                                </>
                                                                :
                                                                <div className="error-text">
                                                                    Please Enter {field?.label} + test
                                                                </div>
                                                            }

                                                        </>
                                                    }
                                                </div>
                                            )}
                                            {field?.type && field?.type === "addDynamicFields" && (
                                                <div className="col-md-9 col-sm-12">
                                                    {!rowsData.length &&
                                                        <div className="pointer mt-2" onClick={() => { addContainerTableRows(field?.key) }}>
                                                            <FontAwesomeIcon icon={faPlus} />
                                                        </div>
                                                    }
                                                    {rowsData?.map((data: any, index: number) => {
                                                        return (
                                                            <div className="row">
                                                                {data &&
                                                                    <>
                                                                        {field?.dynamicFields.map((item: any) => {
                                                                            const { key, label, placeholder } = item;
                                                                            return (
                                                                                <input
                                                                                    type="text"
                                                                                    value={inputs?.["dynamicAddAPIs"]?.[index]?.[key]}
                                                                                    // data[index]?.[key]
                                                                                    name={key}
                                                                                    placeholder={placeholder}
                                                                                    onChange={(evnt) => (handleChangeAddAPI(index, evnt))}
                                                                                    className="form-control form-control-bordered col-4 mx-1"
                                                                                />
                                                                            )
                                                                        })}
                                                                    </>
                                                                }
                                                                {(rowsData?.length - 1 === index) ?
                                                                    <div className="pointer col-1 my-2" onClick={() => { addContainerTableRows(field?.key) }}>
                                                                        <FontAwesomeIcon icon={faPlus} />
                                                                    </div>
                                                                    :
                                                                    <div className="col-1">

                                                                    </div>
                                                                }
                                                                <div className="pointer my-2 col-1" onClick={() => { deleteTableRows(index, field?.key) }}>
                                                                    <FontAwesomeIcon icon={faTrash} />
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                    }
                                                    {/* <span className="input-group-append">
                                            <div className="input-group-text bg-transparent input-clear-pos pointer" onClick={() => { onClearInput(field, field?.dependencyList) }}>
                                                <FontAwesomeIcon icon={faTimes} />
                                            </div>
                                        </span> */}
                                                </div>
                                            )
                                            }
                                            {field?.type && field?.type === "select" && (
                                                <div className="col-md-6 col-sm-12">
                                                    <div className="d-flex">
                                                        <select
                                                            className={classNames("form-control",
                                                                {
                                                                    "form-missing-bordered ": finalSubmit && !inputs[field?.key],
                                                                    "form-control-bordered": inputs[field?.key] || !inputs[field?.key]
                                                                },
                                                            )}
                                                            placeholder={field?.placeholder}
                                                            onChange={(e) => { handleChange(e, field?.dependencyList) }}
                                                            name={field?.key}
                                                            value={inputs[field?.key] || ""}
                                                        >
                                                            <option value="">Select</option>
                                                            {
                                                                field?.options && field?.options?.map((item: any, index: number) => {
                                                                    return (
                                                                        <>
                                                                            {item?.selected === true ?
                                                                                <option value={item.value} key={index} selected>{item.label}</option>
                                                                                :
                                                                                <option value={item.value} key={index}>{item.label}</option>
                                                                            }
                                                                        </>
                                                                    )
                                                                }
                                                                )
                                                            }
                                                        </select>
                                                        <span className="input-group-append">
                                                            <div
                                                                className="input-group-text bg-transparent input-clear-pos pointer"
                                                                onClick={() => { onClearInput(field, field?.dependencyList) }}>
                                                                <FontAwesomeIcon icon={faTimes} />
                                                            </div>
                                                        </span>
                                                    </div>
                                                    {finalSubmit && !inputs[field?.key] && field.required &&
                                                        <div className="error-text">
                                                            Please Select {field?.label}
                                                        </div>
                                                    }
                                                </div>
                                            )}
                                            {field?.type && field?.type === "password" && (
                                                <div className="col-md-6 col-sm-12 d-flex">
                                                    <input
                                                        type={hideShowPassword[field?.key] ? "password" : "text"}
                                                        name={field?.key}
                                                        value={inputs[field?.key] || ""}
                                                        className="form-control form-control-bordered "
                                                        placeholder={field?.placeholder}
                                                        disabled={field?.disabled}
                                                        onChange={(e) => handleChange(e)}
                                                    />
                                                    <div className="mt-1 pointer">
                                                        {icon === "faEyeSlash" && field?.hide ?
                                                            <FontAwesomeIcon onClick={() => { show(icon, field?.key) }} icon={faEyeSlash} />
                                                            :
                                                            <FontAwesomeIcon onClick={() => { show(icon, field?.key) }} icon={faEye} />
                                                        }
                                                    </div>
                                                    {/* <i onClick={show} className={icon}></i> */}
                                                </div>
                                            )}
                                            {field?.type && field?.type === "checkBox" && (
                                                <div className="col-md-6 col-sm-12">
                                                    <input
                                                        type="checkbox"
                                                        className="pointer"
                                                        key={Math.random()}
                                                        name={field?.key}
                                                        checked={inputs[field?.key] || false}
                                                        onChange={(e) => { handleCheckBox(e, field?.dependencyList, field) }}
                                                    />
                                                    <label className="m-1">
                                                        {field.label}
                                                    </label>
                                                    {field.required &&
                                                        <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                                    }

                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </>
                            :
                            <p>No Data Available</p>
                        }
                    </div>
                    :
                    <div>
                        <div className="m-2 row">
                            {requiredFields?.length ?
                                <>
                                    {requiredFields?.length && Object.keys(inputs).length && requiredFields?.map((field: any) => {
                                        return (
                                            <div className="col-md-6 col-sm-12 my-2">
                                                {field?.type &&
                                                    <> {field?.type !== "checkBox" &&
                                                        <div className="d-flex col-md-12 col-sm-12">
                                                            <label className="field-label">
                                                                {field?.label}
                                                                {field.optional && (
                                                                    <span className="optional">(optional)</span>
                                                                )}
                                                            </label>
                                                            {field.required &&
                                                                <span className='text-mandatory fs-16 ml-1'><b>*</b></span>
                                                            }
                                                            {field?.tooltip && (
                                                                <div className="ml-2">
                                                                    <div className="pointer" data-toggle="tooltip" data-placement="top" title={field?.tip}>
                                                                        <FontAwesomeIcon icon={faInfoCircle} className="m-0 ps-1 fontCircleInfo" />
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    }
                                                    </>
                                                }
                                                {field?.type && field?.type === "input" && field?.dataType !== "number" && (
                                                    <div >
                                                        <div className="d-flex">
                                                            <input
                                                                type={field?.dataType}
                                                                name={field?.key}
                                                                value={inputs[field?.key] || ""}
                                                                id={field?.key}
                                                                className="form-control form-control-bordered"
                                                                placeholder={field?.placeholder}
                                                                required={field.required ? field.required : false}
                                                                disabled={field?.disableDependency ? (inputs?.[field?.disableDependency] === true ? false : true) : false}
                                                                onChange={(e) => { field?.restrictSpecialCharacters ? handleChange(e, {}, field?.restrictSpecialCharacters, field) : handleChange(e, {}, false, field) }}
                                                            />
                                                            <span className="input-group-append">
                                                                <div className="input-group-text bg-transparent input-clear-pos pointer" onClick={() => { onClearInput(field?.key) }}>
                                                                    <FontAwesomeIcon icon={faTimes} />
                                                                </div>
                                                            </span>
                                                        </div>
                                                        {finalSubmit && !inputs[field?.key] && field.required &&
                                                            <div className="error-text">
                                                                Please Enter {field?.label}
                                                            </div>
                                                        }
                                                    </div>
                                                )}
                                                {field?.type && field?.type === "input" && field?.dataType === "number" && (
                                                    <div >
                                                        <div className="d-flex">
                                                            <input
                                                                type="number"
                                                                name={field?.key}
                                                                value={typeof (inputs[field?.key]) === "number" ? inputs[field?.key] : ""}
                                                                // defaultValue={inputs[field?.key]}
                                                                id={field?.key}
                                                                className="form-control form-control-bordered"
                                                                placeholder={field?.placeholder}
                                                                required={field.required ? field.required : false}
                                                                disabled={field?.disableDependency ? (inputs?.[field?.disableDependency] === true ? false : true) : false}
                                                                onChange={(e: any) => { field?.restrictSpecialCharacters ? handleChange(e, {}, field?.restrictSpecialCharacters, field) : handleChange(e, {}, false, field) }}
                                                            />
                                                            <span className="input-group-append">
                                                                <div className="input-group-text bg-transparent input-clear-pos pointer" onClick={() => { onClearInput(field?.key) }}>
                                                                    <FontAwesomeIcon icon={faTimes} />
                                                                </div>
                                                            </span>
                                                        </div>
                                                        {/* <>{typeof (inputs[field?.key])}</> */}
                                                        {finalSubmit && typeof (inputs[field?.key]) !== "number" && field.required &&
                                                            <div className="error-text">
                                                                Please Enter {field?.label}
                                                            </div>
                                                        }
                                                    </div>
                                                )}
                                                {field?.type && field?.type === "addDynamicFields" && (
                                                    <div>
                                                        {!rowsData.length &&
                                                            <div className="pointer mt-2" onClick={() => { addContainerTableRows(field?.key) }}>
                                                                <FontAwesomeIcon icon={faPlus} />
                                                            </div>
                                                        }
                                                        {rowsData?.map((data: any, index: number) => {
                                                            return (
                                                                <div className="row">
                                                                    {data &&
                                                                        <>
                                                                            {field?.dynamicFields.map((item: any) => {
                                                                                const { key, label, placeholder } = item;
                                                                                return (
                                                                                    <input
                                                                                        type="text"
                                                                                        value={inputs?.["dynamicAddAPIs"]?.[index]?.[key]}
                                                                                        // data[index]?.[key]
                                                                                        name={key}
                                                                                        placeholder={placeholder}
                                                                                        onChange={(evnt) => (handleChangeAddAPI(index, evnt))}
                                                                                        className="form-control form-control-bordered col-4 mx-1"
                                                                                    />
                                                                                )
                                                                            })}
                                                                        </>
                                                                    }
                                                                    {(rowsData?.length - 1 === index) ?
                                                                        <div className="pointer col-1 my-2" onClick={() => { addContainerTableRows(field?.key) }}>
                                                                            <FontAwesomeIcon icon={faPlus} />
                                                                        </div>
                                                                        :
                                                                        <div className="col-1">

                                                                        </div>
                                                                    }
                                                                    <div className="pointer my-2 col-1" onClick={() => { deleteTableRows(index, field?.key) }}>
                                                                        <FontAwesomeIcon icon={faTrash} />
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                        }
                                                        {/* <span className="input-group-append">
                                            <div className="input-group-text bg-transparent input-clear-pos pointer" onClick={() => { onClearInput(field, field?.dependencyList) }}>
                                                <FontAwesomeIcon icon={faTimes} />
                                            </div>
                                        </span> */}
                                                    </div>
                                                )
                                                }
                                                {field?.type && field?.type === "select" && (
                                                    <div>
                                                        <div className="d-flex">
                                                            <select
                                                                className="form-control form-control-bordered"
                                                                placeholder={field?.placeholder}
                                                                onChange={(e) => { handleChange(e, field?.dependencyList) }}
                                                                name={field?.key}
                                                                value={inputs[field?.key] || ""}
                                                            >
                                                                <option value="">Select</option>
                                                                {
                                                                    field?.options && field?.options?.map((item: any, index: number) => {
                                                                        return (
                                                                            <>
                                                                                {item?.selected === true ?
                                                                                    <option value={item.value} key={index} selected>{item.label}</option>
                                                                                    :
                                                                                    <option value={item.value} key={index}>{item.label}</option>
                                                                                }
                                                                            </>
                                                                        )
                                                                    }
                                                                    )
                                                                }
                                                            </select>
                                                            <span className="input-group-append">
                                                                <div className="input-group-text bg-transparent input-clear-position pointer" onClick={() => { onClearInput(field, field?.dependencyList) }}>
                                                                    <FontAwesomeIcon icon={faTimes} />
                                                                </div>
                                                            </span>
                                                        </div>
                                                        {finalSubmit && !inputs[field?.key] && field.required &&
                                                            <div className="error-text">
                                                                Please Select {field?.label}
                                                            </div>
                                                        }
                                                    </div>
                                                )}
                                                {field?.type && field?.type === "password" && (
                                                    <div>
                                                        <input
                                                            type="password"
                                                            name={field?.key}
                                                            value={inputs[field?.key] || ""}
                                                            className="form-control form-control-bordered "
                                                            placeholder={field?.placeholder}
                                                            disabled={field?.disabled}
                                                            onChange={(e) => handleChange(e)}
                                                        />
                                                    </div>
                                                )}
                                                {field?.type && field?.type === "checkBox" && (
                                                    <div >
                                                        <input
                                                            type="checkbox"
                                                            className="pointer"
                                                            key={Math.random()}
                                                            name={field?.key}
                                                            checked={inputs[field?.key] || false}
                                                            onChange={(e) => { handleCheckBox(e, field?.dependencyList, field) }}
                                                        />
                                                        <label className="m-1">
                                                            {field.label}
                                                        </label>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </>
                                :
                                <p>No Data Available</p>
                            }
                        </div>
                    </div>
                }
            </form >
        </div >
    );
}